module.exports = __webpack_public_path__ + "img/happy.be5030ca.webp";